import React from 'react'
import PropTypes from 'prop-types'
import { ChipGroup } from '@walmart-web/livingdesign-components'
import Slider from 'react-slick'

import ChipImage from './ChipImage'
import { getCarouselSettings } from '../helper/getCarouselSettings'
import './CarouselVariant.css'

const CarouselVariant = (props) => {
  const { variants, product, handleVariantClick, primaryAttribute } = props
  const carouselSettings = getCarouselSettings(variants)

  return (
    <>
      <ChipGroup UNSAFE_className="carousel-variant__chip-group-container">
        <Slider {...carouselSettings}>
          {variants.map((variant) => {
            const [defaultSize] = variant.sizes
            const variantUrlImg = variant.images.mediumImage
            const disabled = !variant.available

            return (
              <ChipImage
                key={`${primaryAttribute}-${variant[primaryAttribute]}`}
                primaryAttribute={primaryAttribute}
                primaryVariant={variant}
                secondaryVariant={defaultSize}
                product={product}
                handleVariantClick={handleVariantClick}
                variantUrlImg={variantUrlImg}
                disabled={disabled}
              />
            )
          })}
        </Slider>
      </ChipGroup>
    </>
  )
}

CarouselVariant.propTypes = {
  variants: PropTypes.array.isRequired,
  product: PropTypes.object.isRequired,
  primaryAttribute: PropTypes.string.isRequired,
  handleVariantClick: PropTypes.func.isRequired,
}

export default CarouselVariant
